import styled from "styled-components";

export const BrandEnterprise = styled.div`
  background-image:     url(${process.env.REACT_APP_BACKGROUND});
  background-size:      cover;
  background-position:  center;
`;
